<template>
  <v-tooltip top>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        icon
        dark
        width="30"
        height="30"
        :style="{
          'background-color': !(isEmptyPurpose || isEmptySourceOfFund || isPendingAlertCase || isPendingRiskAssessment) ? '#2C6CD3' : '#A1A1A4',
          'margin-right': '20px'
        }"
        v-on="on"
        v-bind="attrs"
      >
        <v-img
          dark
          :src="icons.cdd"
          width="17"
          max-height="13"
          contain
        />
      </v-btn>
    </template>
    <span>
      {{
        (isEmptyPurpose || isEmptySourceOfFund || isPendingAlertCase || isPendingRiskAssessment)
          ? $t('transaction.details.pending_for_cdd.options[1]')
          : $t('transaction.details.pending_for_cdd.options[0]')
      }}
      <v-simple-table
        dense
        style="background: transparent; color: white; font-size: 12px;"
      >
        <template v-slot:default>
          <tbody>
            <tr>
              <td>{{ $t('transaction.details.pending_for_cdd.condition.source_of_fund') }}</td>
              <td :style="{ color: isEmptySourceOfFund ? 'red' : 'white' }">
                <v-icon dark>{{ isEmptySourceOfFund ? 'mdi-close' : 'mdi-check' }}</v-icon>
              </td>
            </tr>
            <tr>
              <td>{{ $t('transaction.details.pending_for_cdd.condition.purpose') }}</td>
              <td>
                <v-icon dark>{{ isEmptyPurpose ? 'mdi-close' : 'mdi-check' }}</v-icon>
              </td>
            </tr>
            <tr>
              <td>{{ $t('transaction.details.pending_for_cdd.condition.alert_case') }}</td>
              <td :style="{ color: isPendingAlertCase ? 'red' : 'white' }">
                <v-icon dark>{{ isPendingAlertCase ? 'mdi-close' : 'mdi-check' }}</v-icon>
              </td>
            </tr>
            <tr>
              <td>{{ $t('transaction.details.pending_for_cdd.condition.risk_assessment') }}</td>
              <td>
                <v-icon dark>{{ isPendingRiskAssessment ? 'mdi-close' : 'mdi-check' }}</v-icon>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </span>
  </v-tooltip>
</template>

<script>
import svgCDD from '@/assets/images/transaction/ic_tx_cdd.svg'

export default {
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    icons () {
      return {
        cdd: svgCDD
      }
    },
    isPendingAlertCase () {
      return this.item?.alert_case?.cnt_pending > 0
    },
    isEmptyPurpose () {
      return !this.item?.purpose
    },
    isEmptySourceOfFund () {
      return !this.item?.source_of_fund
    },
    isPendingRiskAssessment () {
      return this.item?.risk_assessments?.length === 0
    }
  }
}
</script>
